<script>
import ConversationCard from './widgets/conversation/ConversationCard.vue';
export default {
  components: {
    ConversationCard,
  },
  inject: [
    'selectConversation',
    'deSelectConversation',
    'assignAgent',
    'assignTeam',
    'assignLabels',
    'transferInbox',
    'updateConversationStatus',
    'toggleContextMenu',
    'markAsUnread',
    'markAsRead',
    'assignPriority',
    'isConversationSelected',
    'deleteConversation',
  ],
  props: {
    source: {
      type: Object,
      required: true,
    },
    teamId: {
      type: [String, Number],
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    conversationType: {
      type: String,
      default: '',
    },
    foldersId: {
      type: [String, Number],
      default: 0,
    },
    showAssignee: {
      type: Boolean,
      default: false,
    },
    kanbanItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localKanbanItem: this.kanbanItem,
    };
  },
  watch: {
    kanbanItem(newValue) {
      this.localKanbanItem = newValue;
    },
  },
  methods: {
    updateKanbanItem(newItem) {
      this.localKanbanItem = newItem;
      this.$emit('update:kanbanItem', newItem);
    },
  },
};
</script>

<template>
  <ConversationCard
    :key="source.id"
    :active-label="label"
    :team-id="teamId"
    :folders-id="foldersId"
    :chat="source"
    :conversation-type="conversationType"
    :selected="isConversationSelected(source.id)"
    :show-assignee="showAssignee"
    :kanban-item="localKanbanItem"
    enable-context-menu
    @select-conversation="selectConversation"
    @de-select-conversation="deSelectConversation"
    @assign-agent="assignAgent"
    @assign-team="assignTeam"
    @assign-label="assignLabels"
    @transfer-inbox="transferInbox"
    @update-conversation-status="updateConversationStatus"
    @context-menu-toggle="toggleContextMenu"
    @mark-as-unread="markAsUnread"
    @assign-priority="assignPriority"
    @update:kanban-item="updateKanbanItem"
    @mark-as-read="markAsRead"
    @delete-conversation="deleteConversation"
  />
</template>
